import * as Sentry from '@sentry/react'

import { ONE_MINUTE, ONE_SECOND } from '@/utils/date.ts'

export const APP_VERSION: string = '___APP_VERSION___'
export const BACKEND_BASE_URL: string = '/___SERVICE_BACKEND___'
export const WS_BASE_URL: string = '/___SERVICE_WS___'
// @ts-ignore
export const POLL_INTERVAL: number = '___POLL_INTERVAL___'
export const RETRY_REQUEST_INITIAL_DELAY = ONE_SECOND * 3
export const RETRY_REQUEST_MAX_DELAY = ONE_SECOND * 10
export const RETRY_WS_INITIAL_DELAY = ONE_SECOND * 3
export const RETRY_WS_MAX_DELAY = ONE_MINUTE * 5
export const WS_KEEP_ALIVE = ONE_SECOND * 5

export const MAX_ATTACHMENT_SIZE_IN_MB = 20
export const MEGABYTE = 1024 * 1024

export const endSentrySession = () => {
  Sentry.endSession()
  Sentry.close().finally(() => sessionStorage.removeItem('sentryReplaySession'))
}

export const startSentrySession = () => {
  Sentry.startSession()
}

export const initializeSentry = () => {
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: 'https://88ff1b13d2105fc52282aa9735f499e3@o4508991454445568.ingest.us.sentry.io/4508996305944576',
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ['.*'],
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      environment: 'production',
    })
  }
}

export const getPageTitlePrefix = () => {
  if (window.location.hostname.startsWith('dev.')) {
    document.title = `[DEV] ${document.title}`
  } else if (window.location.port === '5173') {
    document.title = `[LOCAL] ${document.title}`
  }
}
